import React, {useMemo} from 'react';

const colors = ['#69D994', '#9DDEAD', '#B3E5C2', '#E5F6EB'];
const bubbleCount = 60;

const randRange = (min: number, max: number) => (
	Math.random() * (max - min) + min
);

const useFastBubbles = () => (
	useMemo(() => {
		const generated: JSX.Element[] = [];
		for (let i = 0; i < bubbleCount; i++) {
			const size = randRange(1, 6);
			const colorIndex = i % 4;
			const speed = randRange(5, 6);
			const delay = randRange(-20, 0); // Negative delay for immediate start at different positions

			// Random horizontal movement
			const xStart = randRange(25, 75);
			const xAmplitude = randRange(5, 20);
			const xMid = Math.max(25, Math.min(75, xStart + randRange(-1, 1) * xAmplitude));
			const xEnd = Math.max(25, Math.min(75, xMid + randRange(-1, 1) * xAmplitude));

			// Upward movement with looping
			const yStart = randRange(100, 120); // Start below screen
			const yEnd = randRange(-20, 0); // End above screen

			generated.push(
				<circle
					key={i}
					cx={xStart}
					cy={yStart}
					r={size}
					fill='none'
					stroke={colors[colorIndex]}
					strokeWidth='1'
					opacity='0.7'
				>
					<animate
						attributeName='cx'
						values={`${xStart};${xMid};${xEnd};${xMid};${xStart}`}
						dur={`${speed * 2}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/>
					<animate
						attributeName='cy'
						values={`${yStart};${yEnd}`}
						dur={`${speed * 3}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/>
					<animate
						attributeName='r'
						values={`${size};${size*1.3};${size}`}
						dur={`${speed}s`}
						begin={`${delay}s`}
						repeatCount='indefinite'
					/>
				</circle>
			);

			// Add solid bubbles too
			if (i % 3 === 0) {
				const solidSize = randRange(0.5, 3.5);
				const xSolidStart = randRange(0, 100);
				const xSolidAmplitude = randRange(5, 20);
				const xSolidMid = Math.max(0, Math.min(100, xSolidStart + randRange(-1, 1) * xSolidAmplitude));
				const xSolidEnd = Math.max(0, Math.min(100, xSolidMid + randRange(-1, 1) * xSolidAmplitude));
				const ySolidStart = randRange(100, 120);
				const ySolidEnd = randRange(-40, -20);
				const solidSpeed = randRange(3, 6);
				const solidDelay = randRange(-20, 0);

				generated.push(
					<circle
						key={`solid-${i}`}
						cx={xSolidStart}
						cy={ySolidStart}
						r={solidSize}
						fill={colors[colorIndex]}
						opacity='0.6'
					>
						<animate
							attributeName='cx'
							values={`${xSolidStart};${xSolidMid};${xSolidEnd};${xSolidMid};${xSolidStart}`}
							dur={`${solidSpeed * 2}s`}
							begin={`${solidDelay}s`}
							repeatCount='indefinite'
						/>
						<animate
							attributeName='cy'
							values={`${ySolidStart};${ySolidEnd}`}
							dur={`${solidSpeed * 2}s`}
							begin={`${solidDelay}s`}
							repeatCount='indefinite'
						/>
					</circle>
				);
			}
		}
		return generated;
	}, [])
);

export const FastBubbles: React.FC = () => {
	const bubbles = useFastBubbles();
	return (
		<div>
			<svg
				width='100%'
				height='100%'
				viewBox='0 0 100 100'
				preserveAspectRatio='none'
			>
				{bubbles}
			</svg>
		</div>
	);
};
